module.exports = __webpack_public_path__ + "static/media/history.36a4363f.jpg";